interface DetailedContent {
  member?: string;
  role?: string;
  activity?: string;
}

export const detailedContent: Record<string, DetailedContent[]> = {
  "2023/2024": [
    { member: "Noah Meland", role: "Leder" },
    { member: "Ola Hagerupsen Hansen", role: "Nestleder" },
    { member: "Agnes Aarsland" },
    { member: "Amalie Johannessen" },
    { member: "Anish Sharma" },
    { member: "Aurora Grongstad-Borsheim" },
    { member: "Baste Brynsrud" },
    { member: "Benjamin Wiig" },
    { member: "Bertine Haukøy" },
    { member: "Cordelia Sørbye" },
    { member: "Elida Kraggerud" },
    { member: "Emilie Lysaker Høgne" },
    { member: "Felix Sun" },
    { member: "Hannah Bjørve Thuen" },
    { member: "Helene Jomaas" },
    { member: "Herman Bergheim" },
    { member: "Ida Harneshaug" },
    { member: "Jan Olav Karlsen" },
    { member: "Karoline Torø" },
    { member: "Kristian Sandernes" },
    { member: "Lars Erik Eide" },
    { member: "Maiken Bergstad Kaarbøe" },
    { member: "Peter Mikalsen" },
    { member: "Ritika Jaswal" },
    { member: "Sander Johansen" },
    { member: "Sigurd Tveter" },
    { member: "Simen Birkeland" },
    { member: "Simen Petersson" },
    { member: "Sina Sprauten" },
    { member: "Sofie Louise von Krogh" },
    { member: "Solveig Aarmo" },
    { member: "Thea Bruno" },
    { member: "Thor Normann Selvik" },
    { member: "William Nyblin" },
    { activity: "56 bedriftspresentasjoner" },
    { activity: "KarriereDagene med 151 bedrifter" },
    { activity: "OsloTuren med 150 studenter og 20 bedrifter" },
    { activity: "JobbsøkerDagene med 3 startups, 2 større bedrifter og 2 foredrag" },
    { activity: "En Meningsfylt Hverdag med Indøks Veldedige Initiativ" },
    { activity: "Diplomundersøkelsen" },
    { activity: "Alumniundersøkelsen" },
  ],
  "2022/2023": [
    { member: "Idun Aune Skretting", role: "Leder" },
    { member: "Henrik Sommerseth", role: "Nestleder" },
    { member: "Aakash Balakumar" },
    { member: "Adrian Gran von Hall" },
    { member: "Aina Lie" },
    { member: "Alexandra Axcrona" },
    { member: "Amalie Johannessen" },
    { member: "Anish Deep Sharma" },
    { member: "Aurora Grongstad-Borsheim" },
    { member: "Cathy Ho" },
    { member: "Emilie Lysaker Høgne" },
    { member: "Frederick Pretlove" },
    { member: "Hedda Flemmen Holum" },
    { member: "Herman Bergheim" },
    { member: "Håkon Sønstebø" },
    { member: "Isabel Sandersen" },
    { member: "Jan Olav Karlsen" },
    { member: "Karoline Torø" },
    { member: "Kristin Liaaen" },
    { member: "Lars Erik Eide" },
    { member: "Lene Jakobsen" },
    { member: "Liv Semlitsch" },
    { member: "Magnus Bautz Holter" },
    { member: "Maiken Bergstad Kaarbøe" },
    { member: "Mathea Aune Bardal" },
    { member: "Noah Meland" },
    { member: "Ola Hagerupsen Hansen" },
    { member: "Ritika Jaswal" },
    { member: "Simen Birkeland" },
    { member: "Simen Petersson" },
    { member: "Solveig Aarmo" },
    { member: "Thea Bruno" },
    { member: "Thor Normann Selvik" },
    { member: "Torstein Johnsrud" },
    { activity: "70 bedriftspresentasjoner" },
    { activity: "KarriereDagene med 132 bedrifter" },
    { activity: "OsloTuren med 150 studenter og 20 bedrifter" },
    {
      activity:
        "JobbSøkerGuiden både høst og vår: Visma, Pareto og Bekk på høsten, Visma, BDO, Pareto og Bekk på våren",
    },
    { activity: "Startup-dagen med sju startupbedrifter" },
    { activity: "Diplomundersøkelsen" },
  ],
  "2021/2022": [
    { member: "Vilde Sætre", role: "Leder" },
    { member: "Knut Skjevrak", role: "Nestleder" },
    { member: "Aakash Balakumar" },
    { member: "Adrian Gran von Hall" },
    { member: "Aina Lie" },
    { member: "Alexandra Axcrona" },
    { member: "Arnas Tribusininas" },
    { member: "Benedikte Bitnes" },
    { member: "Cathy Ho" },
    { member: "Christopher Laloi Dybdahl" },
    { member: "Emil Holmen" },
    { member: "Frederick Pretlove" },
    { member: "Hedda Flemmen Holum" },
    { member: "Henrik Sommerseth" },
    { member: "Håkon Sønstebø" },
    { member: "Idun Aune Skretting" },
    { member: "Isabel Sandersen" },
    { member: "Jacob Alexander Worsøe" },
    { member: "Jakob Cuhra" },
    { member: "Johanna Toutain" },
    { member: "Kristin Liaaen" },
    { member: "Kristoffer Grude" },
    { member: "Liv Semlitsch" },
    { member: "Magnus Bautz Holter" },
    { member: "Marcus Fuglestad" },
    { member: "Maria Strand Ryssdal" },
    { member: "Marte Ribe" },
    { member: "Mathea Aune Bardal" },
    { member: "Nicolay Liaaen Hagen" },
    { member: "Tord Johan Espe" },
    { member: "Torstein Johnsrud" },
    { member: "Wilhelm Medhus" },
    { activity: "63 bedriftspresentasjoner, hvorav 5 ble avholdt digitalt" },
    { activity: "KarriereDagene arrangert med hybrid-løsning der 93 bedrifter deltok" },
    { activity: "JobbSøkerGuiden på høsten med Visma, Pareto Securities og Kearney" },
    { activity: "Startup-dagen med åtte startupbedrifter" },
    { activity: "Diplomundersøkelsen" },
  ],
  "2020/2021": [
    { member: "Erlend Heir", role: "Leder" },
    { member: "Nora Kyte", role: "Nestleder" },
    { member: "Arnas Tribusininas" },
    { member: "Asbjørn Nisi" },
    { member: "Benedikte Bitnes" },
    { member: "Benjamin Rike" },
    { member: "Camilla Ulven Børsum" },
    { member: "Christian August Brask Rustad" },
    { member: "Christopher Laloi Dybdahl" },
    { member: "Edvard Hesle" },
    { member: "Emil Holmen" },
    { member: "Emilie Nysted Elvebakk" },
    { member: "Emmiche Advocaat Wigand" },
    { member: "Helene Brøndbo" },
    { member: "Jacob Alexander Worsøe" },
    { member: "Jakob Cuhra" },
    { member: "Johanna Toutain" },
    { member: "Kenneth André Inghelm Mørkved" },
    { member: "Knut Skjevrak" },
    { member: "Konrad Almås" },
    { member: "Kristoffer Grude" },
    { member: "Marcus Fuglestad" },
    { member: "Maria Strand Ryssdal" },
    { member: "Markus Myklebust" },
    { member: "Marte Ribe" },
    { member: "Martin Olderskog" },
    { member: "Nicolay Liaaen Hagen" },
    { member: "Sophie Bjertnæs" },
    { member: "Tord Johan Espe" },
    { member: "Vilde Sætre" },
    { member: "Wilhelm Medhus" },
    { activity: "53 bedpresser, hvorav 44 ble avholdt digitalt" },
    { activity: "KarriereDagene arrangert digitalt med 73 bedrifter" },
    {
      activity:
        "JobbSøkerGuiden både vår og høst. Visma, PwC og ABG deltok på høsten. McKinsey og Visma deltok på våren",
    },
    { activity: "En Meningsfylt Hverdag i samarbeid med Indøks Veldedige Initiativ som en del av JobbSøkerGuiden" },
    { activity: "Startup-uka med fem startupbedrifter" },
  ],
  "2019/2020": [
    { member: "Marthe Kirkeby", role: "Leder" },
    { member: "Morten Haugestøyl Vinje", role: "Nestleder" },
    { member: "Agnes Gehrken Hjeltnes" },
    { member: "Anders Lyholm Limi" },
    { member: "Anders Strand Ryssdal" },
    { member: "Asbjørn Nisi" },
    { member: "Benjamin Rike" },
    { member: "Camilla Ulven Børsum" },
    { member: "Cassandra Wu" },
    { member: "Christopher Laloi Dybdahl" },
    { member: "Edvard Hesle" },
    { member: "Emilie Nysted Elvebakk" },
    { member: "Emmiche Advocaat Wigand" },
    { member: "Erlend Heir" },
    { member: "Hans Markus Jahle" },
    { member: "Hedda Hove Lund" },
    { member: "Helene Brøndbo" },
    { member: "Hjalmar Vinje" },
    { member: "Kenneth André Inghelm Mørkved" },
    { member: "Konrad Almås" },
    { member: "Lars Waage" },
    { member: "Markus Myklebust" },
    { member: "Martin Olderskog" },
    { member: "Nora Kyte" },
    { member: "Sanna Baug Warholm" },
    { member: "Shivam Deep Sharma" },
    { member: "Sigve Boreas Norris" },
    { member: "Sindre Wiiberg" },
    { member: "Sophie Bjertnæs" },
    { member: "Vibeke Kjellevoll" },
    { activity: "53 gjennomførte bedriftspresentasjoner, fem avlyst på grunn av Covid-19" },
    { activity: "KarriereDagene med 132 bedrifter" },
    { activity: "OsloTuren med 150 studenter og 22 bedrifter" },
    { activity: "Alumniundersøkelsen" },
    { activity: "Roadshow i København" },
  ],
  "2019-2020": [
    { member: "Marthe Kirkeby", role: "Leder" },
    { member: "Morten Haugestøyl Vinje", role: "Nestleder" },
    { member: "Agnes Gehrken Hjeltnes" },
    { member: "Anders Lyholm Limi" },
    { member: "Anders Strand Ryssdal" },
    { member: "Asbjørn Nisi" },
    { member: "Benjamin Rike" },
    { member: "Camilla Ulven Børsum" },
    { member: "Cassandra Wu" },
    { member: "Christian August Brask Rustad" },
    { member: "Edvard Hesle" },
    { member: "Emilie Nysted Elvebakk" },
    { member: "Emmiche Advocaat Wigand" },
    { member: "Erlend Heir" },
    { member: "Hans Markus Jahle" },
    { member: "Hedda Hove Lund" },
    { member: "Helene Brøndbo" },
    { member: "Hjalmar Vinje" },
    { member: "Kenneth André Inghelm Mørkved" },
    { member: "Konrad Almås" },
    { member: "Lars Waage" },
    { member: "Markus Myklebust" },
    { member: "Martin Olderskog" },
    { member: "Nora Kyte" },
    { member: "Sanna Baug Warholm" },
    { member: "Shivam Deep Sharma" },
    { member: "Sigve Boreas Norris" },
    { member: "Sindre Wilberg" },
    { member: "Sophie Bjertnæs" },
    { member: "Vibeke Kjellevoll" },
    { activity: "53 gjennomførte bedriftspresentasjoner, fem avlyst på grunn av Covid-19" },
    { activity: "KarriereDagene med 132 bedrifter" },
    { activity: "OsloTuren med 150 studenter og 22 bedrifter" },
    { activity: "Alumniundersøkelsen" },
    { activity: "Roadshow i København" },
  ],
  "2018/2019": [
    { member: "Erlend Fossum", role: "Leder" },
    { member: "Olav Lund Vigerust", role: "Nestleder" },
    { member: "Agnes Roll-Matthiesen" },
    { member: "Agnes Gehrken Hjeltnes" },
    { member: "Amalie Omholt Ellestad" },
    { member: "Anders Lyholm Limi" },
    { member: "Anders Strand Ryssdal" },
    { member: "Camilla Andersson" },
    { member: "Cassandra Wu" },
    { member: "Catherine Xu" },
    { member: "Cecilie Høgset" },
    { member: "Erling Stray Bugge" },
    { member: "Fattir Ahmed Chaudhary" },
    { member: "Hans Markus Jahle" },
    { member: "Hedda Hove Lund" },
    { member: "Henrik Irgens Gravdal" },
    { member: "Hjalmar Vinje" },
    { member: "Håkon Stubhaug Drangsland" },
    { member: "Katarina Van De Pontseele" },
    { member: "Lars Waage" },
    { member: "Morten Haugestøyl Vinje" },
    { member: "Magnus Ulvik" },
    { member: "Maria Grohshennig" },
    { member: "Marthe Kirkeby" },
    { member: "Sanna Baug Warholm" },
    { member: "Shivam Deep Sharma" },
    { member: "Sigve Boreas Norris" },
    { member: "Sina Fattnes" },
    { member: "Sindre Wilberg" },
    { member: "Thomas Alsten" },
    { member: "Vibeke Kjellevoll" },
    { activity: "63 bedriftspresentasjoner" },
    { activity: "KarriereDagene med 130 bedrifter" },
    { activity: "OsloTuren med 24 bedrifter. PwC og Cognite var samarbeidspartnere" },
    { activity: "JobbSøkerGuiden både vår og høst: EY, ABG og Bain på høsten. ABG og Bain på våren" },
    { activity: "En Meningsfylt Hverdag i samarbeid med FN-studentene og Indøks Veldedige Initiativ" },
    { activity: "Startup-dagen ble arrangert med seks startups" },
    { activity: "Roadshow i Stockholm" },
  ],
  "2017/2018": [
    { member: "Karl Petter Ulsrud", role: "Leder" },
    { member: "Anders Vandvik", role: "Nestleder" },
    { member: "Agnes Roll-Matthiesen" },
    { member: "Amalie Omholt Ellestad" },
    { member: "Bendik Edvardsen" },
    { member: "Bendik Nordeng" },
    { member: "Camilla Andersson" },
    { member: "Catherine Xu" },
    { member: "Cecilie Høgset" },
    { member: "Erlend Johnsen Fossum" },
    { member: "Erling Stray Bugge" },
    { member: "Fattir Ahmed Chaudhary" },
    { member: "Håkon Stubhaug Drangsland" },
    { member: "Hannah Emilie Hjelle Høydal" },
    { member: "Henrik Dybevold Hesle" },
    { member: "Henrik Irgens Gravdal" },
    { member: "Herman Hartgen" },
    { member: "Ingrid Volden Smehagen" },
    { member: "Jon Riege" },
    { member: "Katarina Van De Pontseele" },
    { member: "Katharina Palm" },
    { member: "Kristian Schnell" },
    { member: "Lars Christian Ek Folkestad" },
    { member: "Magnus Ulvik" },
    { member: "Maria Grohshennig" },
    { member: "Martine Svagård" },
    { member: "Olav Lund Vigerust" },
    { member: "Peder Møyner Lund" },
    { member: "Peter Elias Halle Stai" },
    { member: "Sina Fattnes" },
    { member: "Thomas Alsten" },
    { activity: "57 bedriftspresentasjoner" },
    { activity: "KarriereDagene med 130 bedrifter" },
    { activity: "OsloTuren med 150 studenter og 25 bedrifter" },
    { activity: "Bindeleddet lanserer app" },
    { activity: "Startup-dagen arrangeres for første gang" },
  ],
  "2016/2017": [
    { member: "Siri Ulltveit-Moe", role: "Leder" },
    { member: "Helena Van de Pontseele", role: "Nestleder" },
    { member: "Amanda Borge Byrkjeland" },
    { member: "Anders Helgeland Vandvik" },
    { member: "Andreas Huse" },
    { member: "Bendik Edvardsen" },
    { member: "Bendik Nordeng" },
    { member: "Carl Fredrik Lystad" },
    { member: "Caroline Myrland" },
    { member: "Daniel Kittilsen Henriksen" },
    { member: "Emil Johan Verlo Ifwarsson" },
    { member: "Håkon Ringdal" },
    { member: "Hannah Emilie Hjelle Høydal" },
    { member: "Hanne Nicole Haukland Briedis" },
    { member: "Henrik Dybevold Hesle" },
    { member: "Herman Hartgen" },
    { member: "Ingrid Volden Smehagen" },
    { member: "Jon Riege" },
    { member: "Karl Petter Ulsrud" },
    { member: "Katharina Palm" },
    { member: "Kristian Schnell" },
    { member: "Lars Christian Ek Folkestad" },
    { member: "Lars Erik Kleiven" },
    { member: "Lina Lynås" },
    { member: "Martin Willoch Olstad" },
    { member: "Martine Svagård" },
    { member: "Miriam Huse" },
    { member: "Peder Gjerstad" },
    { member: "Peder Møyner Lund" },
    { member: "Peter Elias Halle Stai" },
    { member: "Sofie Aslaksen" },
    { activity: "50 bedriftspresentasjoner" },
    { activity: "KarriereDagene med 120 bedrifter" },
    { activity: "OsloTuren med 120 studenter og 20 bedrifter" },
    { activity: "Diplomundersøkelse" },
    { activity: "JobbSøkerGuiden med ABG og Bain & Company" },
    { activity: "Globalizing Gløs" },
  ],
  "2015/2016": [
    { member: "Tuve Hexeberg Evensen", role: "Leder" },
    { member: "Karstein Brynestad", role: "Nestleder" },
    { member: "Amanda Borge Byrkjeland" },
    { member: "Andreas Huse" },
    { member: "Anne Marie Waage Enger" },
    { member: "August Jacob Kjellevold Holm" },
    { member: "Caroline Myrland" },
    { member: "Daniel Kittilsen Henriksen" },
    { member: "Eirun Nyberget" },
    { member: "Emil Johan Verlo Ifwarsson" },
    { member: "Håkon Ringdal" },
    { member: "Håkon Fredrik Ruud" },
    { member: "Hanne Nicole Haukland Briedis" },
    { member: "Helena Van de Pontseele" },
    { member: "Jon Eide Johnsen" },
    { member: "Kari Elisabeth Eide Hartvedt" },
    { member: "Katrine Erskine" },
    { member: "Lars Erik Kleiven" },
    { member: "Lina Lynås" },
    { member: "Linn Ornum" },
    { member: "Markus Karlsen" },
    { member: "Martin Willoch Olstad" },
    { member: "Michelle Hasle" },
    { member: "Miriam Huse" },
    { member: "Oscar Mathias Brakstad" },
    { member: "Peder Gjerstad" },
    { member: "Petter Aas" },
    { member: "Petter Haga" },
    { member: "Sander Coates" },
    { member: "Siri Ulltveit-Moe" },
    { member: "Sofie Aslaksen" },
    { member: "Sofie Thorleifsson" },
    { member: "Vasuki Vaseeharanathan" },
    { activity: "70 bedriftspresentasjoner" },
    { activity: "KarriereDagen med 140 bedrifter" },
    { activity: "LondonTur med 20 studenter og 4 bedrifter" },
    { activity: "OsloTuren med 150 studenter og 20 bedrifter" },
    { activity: "Roadshow i Oslo og Bergen" },
    { activity: "Diplomundersøkelse" },
    { activity: "BransjeDagen med Shipping og Forsikring" },
    { activity: "En Meningsfylt Hverdag i samarbeid med studentorganisasjonen Effektiv Alturisme" },
    { activity: "JobbSøkerGuiden med ABG, Visma og Bain & Company" },
    { activity: "Medieoppslag i Under Dusken, Adressa, DN og e24" },
  ],
  "2014/2015": [
    { member: "Aksel Reiten", role: "Leder" },
    { member: "Tobias R. Pettrém", role: "Nestleder" },
    { member: "Allan D'Silva" },
    { member: "Ane Landsem" },
    { member: "Anne Hukkelberg" },
    { member: "Anne Marie Waage Enger" },
    { member: "August Jacob Kjellevold Holm" },
    { member: "Carl Andreas Julsvoll" },
    { member: "Christina Væting Nergård" },
    { member: "Eirun Nyberget" },
    { member: "Fredrik Hausken" },
    { member: "Håkon Fredrik Ruud" },
    { member: "Jesper Krogstad" },
    { member: "Jon Eide Johnsen" },
    { member: "Karstein Brynestad" },
    { member: "Katrine Erskine" },
    { member: "Kristine Hagen" },
    { member: "Magnus Mellem" },
    { member: "Markus Karlsen" },
    { member: "Marius Lie Morken" },
    { member: "Marianne Landa" },
    { member: "Martin Fredrik Olsen" },
    { member: "Mats Erik Mikkelsen" },
    { member: "Pavel Palchykov" },
    { member: "Petter Aas" },
    { member: "Petter Haga" },
    { member: "Sander Coates" },
    { member: "Simen Hellem" },
    { member: "Sofie Thorleifsson" },
    { member: "Susanne Irgens Gravdal" },
    { member: "Tuve Hexeberg Evensen" },
    { member: "Vasuki Vaseeharanathan" },
    { activity: "70 bedriftspresentasjoner" },
    { activity: "KarriereDagen med 140 bedrifter" },
    { activity: "LondonTur med 20 studenter og 4 bedrifter" },
    { activity: "OsloTuren med 150 studenter og 20 bedrifter" },
    { activity: "Roadshow i Oslo og Bergen" },
    { activity: "Diplomundersøkelse" },
    { activity: "BransjeDagen med Shiping og Forsikring" },
    { activity: "En Meningsfylt Hverdag i samarbeid med studentorganisasjonen Effektiv Alturisme" },
    { activity: "JobbSøkerGuiden med ABG, Visma og Bain & Company" },
    { activity: "Medieoppslag i Under Dusken, Adressa, DN og e24" },
  ],
  "2013/2014": [
    { member: "Magnus Witzøe", role: "Leder" },
    { member: "Ole Christian Wendel", role: "Nestleder" },
    { member: "Aksel Reiten" },
    { member: "Allan DSilva" },
    { member: "Alvilde Storbråten" },
    { member: "Ana Vukovic" },
    { member: "Ane Landsem" },
    { member: "Anne Hukkelberg" },
    { member: "Carl Andreas Julsvoll" },
    { member: "Christina Knutsen" },
    { member: "Christina Væting Nergård" },
    { member: "Christoffer Wallin" },
    { member: "Eirik Gartland Wahlstrøm" },
    { member: "Hanne Sandven" },
    { member: "Harald Ellingsen" },
    { member: "Jacob Aamodt" },
    { member: "Kjartan Berge Steinshamn" },
    { member: "Kristian Sandaker" },
    { member: "Line Bjerknes" },
    { member: "Linn Ornum" },
    { member: "Marianne Landa" },
    { member: "Mats Erik Mikkelsen" },
    { member: "Nikolai Mathisen Bratsberg" },
    { member: "Oscar Mathias Brakstad" },
    { member: "Paal Olav Mjaugeto" },
    { member: "Pavel Palchykov" },
    { member: "Sigurd Bondahl Mehl" },
    { member: "Sofie Rud Zimmer" },
    { member: "Susanne Irgens Gravdal" },
    { member: "Tobias Pettrem" },
    { activity: "62 bedriftspresentasjoner" },
    { activity: "KarriereDagen med 141 bedrifter" },
    { activity: "OsloTuren med 130 studenter og 19 bedrifter" },
    { activity: "Roadshow i Oslo og London" },
    { activity: "Alumniundersøkelsen" },
    { activity: "BransjeDagen med media, shipping, eiendom og fondsforvaltning" },
    { activity: "En Meningsfylt Hverdag - presentasjon med FN-sambandet og UNICEF" },
    { activity: "JobbSøkerGuiden med ABG, PwC og PA Consulting" },
    { activity: "Medieoppslag i Dagens Næringsliv og E24" },
  ],
  "2012/2013": [
    { member: "Thomas Walle-Hansen", role: "Leder" },
    { member: "Mathilde Fiksdahl", role: "Nestleder" },
    { member: "Alvilde Storbråten" },
    { member: "Ana Vukovic" },
    { member: "Andrea Stephansen" },
    { member: "Cecilie Skjong" },
    { member: "Christoffer Wallin" },
    { member: "Eirik Gartland Wahlstrøm" },
    { member: "Elise Foss" },
    { member: "Håkon Ellekjær" },
    { member: "Hanne Sandven" },
    { member: "Henrik Grødem Sømme" },
    { member: "Jacob Aamodt" },
    { member: "Jacob Henrik Nyman" },
    { member: "Kjartan Berge Steinshamn" },
    { member: "Kristian Sandaker" },
    { member: "Linn Ornum" },
    { member: "Magnus Witzøe" },
    { member: "Marius Lie Morken" },
    { member: "Martin Ringdal" },
    { member: "Mikkel Treu Os" },
    { member: "Nikolai Mathisen Bratsberg" },
    { member: "Olav Nørstebø" },
    { member: "Ole Christian Wendel" },
    { member: "Oscar Mathias Brakstad" },
    { member: "Pernille Cathrine Grüner Brinch" },
    { member: "Sofie Rud Zimmer" },
    { member: "Tallak Bergheim" },
    { activity: "86 bedriftspresentasjoner" },
    { activity: "KarriereDagen med 88 bedrifter" },
    { activity: "LondonTur med 35 studenter og 5 bedrifter" },
    { activity: "OsloTuren med 124 studenter og 19 bedrifter" },
    { activity: "Roadshow i Oslo" },
    { activity: "TrondheimsTuren med Det Norske, PwC og Statoil" },
    { activity: "Diplomundersøkelse" },
    { activity: "BransjeDagen med Energi, Telekom, Internasjonal Karriere og Shipping" },
    {
      activity:
        "Foredrag om nettverksbygging og karriereplanlegging med Even Sandvold Roland, i samarbeid med Timini og Abakus",
    },
    { activity: "En Meningsfylt Hverdag - presentasjon med FN-sambandet og Ingeniører Uten Grenser" },
    { activity: "JobbSøkerGuiden med ABG, McKinsey og Accenture" },
    { activity: "Medieoppslag i Under Dusken, Adressa, DN og e24" },
  ],
  "2011/2012": [
    { member: "Karl Erik Kaurstad Morthen", role: "Leder" },
    { member: "Sven Henrik Andresen", role: "Nestleder" },
    { member: "Andrea Stephansen" },
    { member: "Cecilie Skjong" },
    { member: "Eivind Fossan Aas" },
    { member: "Elise Foss" },
    { member: "Gjertrud Hole Kjøstolfsen" },
    { member: "Henrik Grødem Sømme" },
    { member: "Håkon Ellekjær" },
    { member: "Håkon Stavn Nokhart" },
    { member: "Ida Kopperstad" },
    { member: "Jacob Henrik Nyman" },
    { member: "Line Bjerknes" },
    { member: "Magnus Naustdal" },
    { member: "Marie Ameln" },
    { member: "Marius Lie Morken" },
    { member: "Martin Ringdal" },
    { member: "Mathilde Fiksdahl" },
    { member: "Mikkel Treu Os" },
    { member: "Morten Krüger Hagen" },
    { member: "Nanna Fløgstad Sohlberg" },
    { member: "Olav Nørstebø" },
    { member: "Pernille Cathrine Grüner Brinch" },
    { member: "Siri Olimb Myhre" },
    { member: "Tallak Bergheim" },
    { member: "Thomas Walle-Hansen" },
    { member: "Vilde Feet" },
    { activity: "66 bedriftspresentasjoner" },
    { activity: "KarriereDagen med 86 bedrifter" },
    { activity: "OsloTuren med 120 studenter og 16 bedrifter" },
    { activity: "Roadshow i Oslo og London" },
    { activity: "Diplomundersøkelse" },
    { activity: "Alumniundersøkelse" },
    { activity: "JobbSøkerGuiden med McKinsey, ABG Sundal Collier og Schibsted" },
    { activity: "BransjeDagen med Eiendom, Forsikring, Internasjonal karriere og Medie & Kommunikasjon" },
  ],
  "2010/2011": [
    { member: "Magnus Haug Wanberg", role: "Leder" },
    { member: "Mads Gedde", role: "Nestleder" },
    { member: "Astri Østmo" },
    { member: "Bjørn Erik Heiberg" },
    { member: "Camilla Marie Skogen" },
    { member: "Caroline Heggelund" },
    { member: "Christian Fredrik Scheel" },
    { member: "Einar Bjering" },
    { member: "Eivind Fossan Aas" },
    { member: "Fredrik Ellekjær" },
    { member: "Frida Næss-Ulseth" },
    { member: "Heidi Aarsten" },
    { member: "Karl Erik Kaurstad Morthen" },
    { member: "Magnus Naustdal" },
    { member: "Marie Ameln" },
    { member: "Morten Krüger Hagen" },
    { member: "Marte Hansen" },
    { member: "Martha Bakken" },
    { member: "Martin Opdal" },
    { member: "Nina Buer Johansen" },
    { member: "Ove Mørch" },
    { member: "Sigurd Ulimoen Myhre" },
    { member: "Siri Bruskeland" },
    { member: "Siri Olimb Myhre" },
    { member: "Stine Selje Sunde" },
    { member: "Sven Henrik Andresen" },
    { member: "Thea Kamilla Moholt" },
    { member: "Thomas Walle-Hansen" },
    { member: "Vilde Feet" },
    { activity: "68 bedriftspresentasjoner" },
    { activity: "KarriereDagen med 86 bedrifter" },
    { activity: "KarriereNorge, stand på Stripa" },
    { activity: "OsloTuren med 120 studenter og 17 bedrifter" },
    { activity: "Roadshow i Oslo og København" },
    { activity: "Jobbkatalog for Indøk" },
    { activity: "Diplomundersøkelse" },
    { activity: "TrondheimsTur med Fokus Bank" },
    { activity: "JobbSøkerGuiden med McKinsey, ABG Sundal Collier og Schibsted" },
    { activity: "BransjeDagen med 11 bransjer" },
    { activity: "Medieoppslag i Aftenposten, Hegnar, DN, E24, nrk.no, fvn.no" },
  ],
  "2009/2010": [
    { member: "Erling Laugsand", role: "Leder" },
    { member: "Maria Tanberg Nygård", role: "Nestleder" },
    { member: "Mads Gedde" },
    { member: "André Christoffer Andersen" },
    { member: "Didrik Ellefsen" },
    { member: "Einar Bjering" },
    { member: "Endre Kure" },
    { member: "Espen Åtland" },
    { member: "Geir Martin Bakken" },
    { member: "Hanne Eide Schjølberg" },
    { member: "Maren Omli Flasnes" },
    { member: "Merete Hole" },
    { member: "Sofie Døving Agdestein" },
    { member: "Solveig Ballo" },
    { member: "Tonje Høyland" },
    { member: "Astri Østmo" },
    { member: "Bjørn Erik Heiberg" },
    { member: "Camilla Marie Skogen" },
    { member: "Caroline Heggelund" },
    { member: "Christian Fredrik Scheel" },
    { member: "Håvard Hammer Normann" },
    { member: "Heidi Aarsten" },
    { member: "Martha Bakken" },
    { member: "Martin Opdal" },
    { member: "Nina Buer Johansen" },
    { member: "Ove Mørch" },
    { member: "Sigurd Ulimoen Myhre" },
    { member: "Stine Selje Sunde" },
    { member: "Thomas Walle-Hansen" },
    { member: "Torkjel Hurtig" },
    { activity: "66 bedriftspresentasjoner" },
    { activity: "KarriereDagen med 86 bedrifter" },
    { activity: "TrøndelagsDagen med 26 bedrifter" },
    { activity: "OsloTuren med 80 studenter og 13 bedrifter" },
    { activity: "Roadshow i Oslo og Bergen" },
    { activity: "184 stillingsannonser" },
    { activity: "Jobbkatalog med 65 annonser" },
    { activity: "Diplomundersøkelse" },
    { activity: "Alumniundersøkelse" },
    { activity: "Medieoppslag i DN, Adressa og E24" },
  ],
  "2008/2009": [
    { member: "Erik Sæbu Vatn", role: "Leder" },
    { member: "Martin Lundby", role: "Nestleder" },
    { member: "Kathrine Gundersen" },
    { member: "Magnus Haug Wanberg" },
    { member: "Lise Vassmoen" },
    { member: "Ellen Ueland" },
    { member: "Maren Sleire" },
    { member: "Audun Nordtveit" },
    { member: "Emilie G. Johannesen" },
    { member: "Fredrik Ellekjær" },
    { member: "Håkon Heir" },
    { member: "Harrald Gundersen" },
    { member: "Håvard Andersen" },
    { member: "Ingrid Nagell" },
    { member: "Ingrid Smith-Sivertsen" },
    { member: "Lars Dybsjord Røstad" },
    { member: "Matilda Line" },
    { member: "Signy Vefring" },
    { member: "Sveinung Alvestad" },
    { member: "Vegard Veiteberg" },
    { member: "Victoria Fearnley Landmark" },
    { member: "André Christoffer Andersen" },
    { member: "Didrik Ellefsen" },
    { member: "Einar Bjering" },
    { member: "Endre Kure" },
    { member: "Erling Laugsand" },
    { member: "Espen Åtland" },
    { member: "Geir Martin Bakken" },
    { member: "Hanne Eide Schjølberg" },
    { member: "Maren Omli Flasnes" },
    { member: "Maria Tanberg Nygård" },
    { member: "Merete Hole" },
    { member: "Sofie Døving Agdestein" },
    { member: "Solveig Ballo" },
    { member: "Tonje Høyland" },
    { activity: "67 bedriftspresentasjoner" },
    { activity: "KarriereDagen med 92 bedrifter" },
    { activity: "OsloTuren med 88 studenter og 13 bedrifter" },
    { activity: "TrøndelagsDagen" },
    { activity: "Første Alumnikveld" },
    { activity: "192 stillingsannonser" },
    { activity: "Roadshow i Oslo og Stavanger" },
    { activity: "Satte opp infoskjerm på stripa" },
    { activity: "Jobbkatalog med 77 annonser" },
    { activity: "Faglig foredrag med Accenture" },
    { activity: "Diplomundersøkelse" },
    { activity: "Nye Brosjyrer" },
    { activity: "Medieoppslag i DN, Adressa og E24" },
  ],
  "2007/2008": [
    { member: "Magnus Valmot", role: "Leder" },
    { member: "Mads Gedde", role: "Nestleder" },
    { member: "Mats Beck" },
    { member: "Torbjørn Bjering" },
    { member: "Ingrid Helsingeng" },
    { member: "Kathrine Gundersen" },
    { member: "Kristian Bergaplass" },
    { member: "Erik Sæbu Vatn" },
    { member: "Magnus Haug Wanberg" },
    { member: "Martin Lundby" },
    { member: "Lise Vassmoen" },
    { member: "Ellen Ueland" },
    { member: "Maren Sleire" },
    { member: "Audun Nordtveit" },
    { member: "Emilie G. Johannesen" },
    { member: "Fredrik Ellekjær" },
    { member: "Håkon Heir" },
    { member: "Harrald Gundersen" },
    { member: "Håvard Andersen" },
    { member: "Ingrid Nagel" },
    { member: "Ingrid Smith-Sivertsen" },
    { member: "Lars Dybsjord Røstad" },
    { member: "Matilda Line" },
    { member: "Signy Vefring" },
    { member: "Sveinung Alvestad" },
    { member: "Vegard Veiteberg" },
    { member: "Victoria Fearnley Landmark" },
    { activity: "64 bedriftspresentasjoner" },
    { activity: "KarriereDagen med 94 bedrifter" },
    { activity: "Oslotur" },
    { activity: "TrøndelagsDagen" },
    { activity: "Diplomundersøkelse" },
    { activity: "Alumniundersøkelse" },
    { activity: "Roadshow i Oslo, Bergen og London" },
    { activity: "Medieoppslag i DN, Adressa, og på Hegnar.no" },
  ],
  "2006/2007": [
    { member: "Eirik Hagem", role: "Leder" },
    { member: "Martin Prokosch", role: "Nestleder" },
    { member: "Kathrine Gundersen" },
    { member: "Erik Sæbu Vatn" },
    { member: "Andreas Lindal" },
    { member: "Magnus Haug Wanberg" },
    { member: "Lars Dybsjord Røstad" },
    { member: "Georg Øiesvold" },
    { member: "Martin Lundby" },
    { member: "Ingrid Helsingeng" },
    { member: "Eivind Breiby" },
    { member: "Andreas Heiskel" },
    { member: "Mads Gedde" },
    { member: "Kristian Bergaplass" },
    { member: "Ellen Marie Haarr" },
    { member: "Jarle Skrebergene" },
    { member: "Lise Vassmoen" },
    { member: "Magnus Valmot" },
    { member: "Linn Zachariassen" },
    { member: "Daniel Hågensen" },
    { member: "Ida Kristine Hårstad" },
    { member: "Martin Hjelle" },
    { member: "Ellen Ueland" },
    { member: "Harald Gundersen" },
    { member: "Maren Sleire" },
    { member: "Torbjørn Bjering" },
    { member: "Mats Beck" },
    { activity: "73 bedriftspresentasjoner" },
    { activity: "KarriereDagen - 47 bedrifter" },
    { activity: "Roadshow i London, Stavanger og Oslo" },
    { activity: "Stavangertur" },
    { activity: "Oslotur (foredrag med Manuel Knight)" },
    { activity: "Diplomundersøkelse" },
    { activity: "223 Stillingsannonser" },
    { activity: "TrøndelagsDagen for første gang" },
    { activity: "Lansering av Infoskjerm på Kjel" },
    { activity: "Innføring av SMS-varsling for studenter" },
    { activity: "Ny samarbeidsavtale med Hydro" },
    { activity: "Nyhetsoppslag i N24, DN, Finansavisen, Adressa, Computerworld" },
  ],
  "2005/2006": [
    { member: "Ole Helliesen", role: "Leder" },
    { member: "Petter Haugen", role: "Nestleder" },
    { member: "Mats Beck" },
    { member: "Torbjørn Bjering" },
    { member: "Eivind Breiby" },
    { member: "Marte Sølberg Ellingsen" },
    { member: "Hanne Freberg" },
    { member: "Mads Gedde" },
    { member: "Eirik Hagem" },
    { member: "Kjetil Havn" },
    { member: "Andreas Heiskel" },
    { member: "Ingrid Helsingeng" },
    { member: "Martin N. Hjelle" },
    { member: "Eivind Berge Hofland" },
    { member: "Jo Husebye" },
    { member: "Daniel Hågensen" },
    { member: "Ellen Marie Haarr" },
    { member: "Ida Kristine Hårstad" },
    { member: "Andreas Lindal" },
    { member: "Anette Brustad Mellbye" },
    { member: "Martin Prokosch" },
    { member: "Delia Proteasa" },
    { member: "Jarle Skrebergene" },
    { member: "Birthe Helen Smedsrud" },
    { member: "Magnus Valmot" },
    { member: "Linn Zachariassen" },
    { member: "Georg Øiesvold" },
    { activity: "55 Bedriftspresentasjoner" },
    { activity: "KarriereDagen - 28 bedrifter" },
    { activity: "Oslotur" },
    { activity: "Foredrag med Jens Ulltveit-Moe og Ingebrigt Steen Jensen (Oslotur)" },
    { activity: "Roadshow i Oslo" },
    { activity: "260 stillingsannonser" },
    { activity: "Diplomundersøkelse" },
    { activity: "Alumniundersøkelse" },
    { activity: "Ny Indøk-brosjyre" },
    { activity: "Kurs med Accenture" },
    { activity: "Ny hovedsamarbeidsavtale med Accenture" },
    { activity: "Samarbeidsavtale med Universum" },
    { activity: "Samarbeidsavtale med ijobb.no" },
  ],
  "2004/2005": [
    { member: "Torbjørn Sæthre", role: "Leder" },
    { member: "Cathrine B. Råstad", role: "Nestleder" },
    { member: "Marte Sølberg Ellingsen" },
    { member: "Jon Fløgstad" },
    { member: "Hanne Freberg" },
    { member: "Eirik Hagem" },
    { member: "Petter Haugen" },
    { member: "Kjetil Havn" },
    { member: "Andreas Heiskel" },
    { member: "Oksana Karpenko Hillervik" },
    { member: "Ole Helliesen" },
    { member: "Martin N. Hjelle" },
    { member: "Eivind Berge Hofland" },
    { member: "Jo Huseby" },
    { member: "Inger Knutsen Lian" },
    { member: "Andreas Lindal" },
    { member: "Anette Brustad Mellbye" },
    { member: "Dag Morten Meltveit" },
    { member: "Martin Prokosch" },
    { member: "Delia Proteasa" },
    { member: "Birthe Helen Smedsrud" },
    { member: "Linn Zachariassen" },
    { member: "Georg Øiesvold" },
    { member: "Thomas Aas" },
    { member: "Tone Aass" },
    { activity: "44 Bedriftspresentasjoner" },
    { activity: "KarriereDagen - 24 bedrifter" },
    { activity: "Oslotur" },
    { activity: "Stavangertur" },
    { activity: "Roadshow i Oslo" },
    { activity: "93 stillingsannonser" },
    { activity: "Diplomundersøkelse" },
    { activity: "Nyhetsbrev" },
    { activity: "Foredrag" },
    { activity: "Ny Bindeleddet-brosjyre" },
  ],
  "2003/2004": [
    { member: "Jon Birger Syvertsen", role: "Leder" },
    { member: "Johann Yoon", role: "Nestleder" },
    { member: "Hilde Charlotte Dahl" },
    { member: "Stian Daazenko" },
    { member: "Ole Håkon Eek-Nielsen" },
    { member: "Jon Fløgstad" },
    { member: "Jørgen Færevåg" },
    { member: "Petter Haugen" },
    { member: "Vebjørn T. Haugerud" },
    { member: "Kjetil Havn" },
    { member: "Ole Helliesen" },
    { member: "Birger Ø. Holo" },
    { member: "Jo Husebye" },
    { member: "Andreas Jordell" },
    { member: "Oksana Karpenko" },
    { member: "Inger Knutsen Lian" },
    { member: "Anette Brustad Mellbye" },
    { member: "Simen M. Nerbøvik" },
    { member: "David Nome" },
    { member: "Delia Proteasa" },
    { member: "Cathrine Råstad" },
    { member: "Håkon Skånhaug" },
    { member: "Torbjørn Sætre" },
    { member: "Arne Johan Valen-Sendstad" },
    { member: "Linn Zachariassen" },
    { member: "Guttorm Aase" },
    { member: "Tone Aass" },
    { activity: "21 Bedriftspresentasjoner" },
    { activity: "Oslotur" },
    { activity: "Roadshow i Bergen, Haugesund og Stavanger" },
    { activity: "Roadshow i Oslo" },
    { activity: "Sommerjobber" },
    { activity: "Diplomundersøkelse" },
    { activity: "Alumniundersøkelse" },
    { activity: "Nyhetsbrev" },
    { activity: "Ny Bindeleddsbrosjyre" },
    { activity: "Debatt med Accenture" },
    { activity: "Foredrag" },
  ],
  "2002/2003": [
    { member: "Ole Håkon Eek-Nielsen", role: "Leder" },
    { member: "Arne Johan Valen-Sendstad", role: "Nestleder" },
    { member: "Espen Berge" },
    { member: "Hilde Charlotte Dahl" },
    { member: "Stian Daazenko" },
    { member: "Jon Fløgstad" },
    { member: "Jørgen Færevåg" },
    { member: "Vebjørn T. Haugerud" },
    { member: "Kjetil Havn" },
    { member: "Nina Holck-Steen" },
    { member: "Birger Ø. Holo" },
    { member: "Elin Irgens" },
    { member: "Andreas Jordell" },
    { member: "Oksana Karpenko" },
    { member: "Inger Knutsen Lian" },
    { member: "Simen M. Nerbøvik" },
    { member: "David Magnus Nome" },
    { member: "Cathrine Råstad" },
    { member: "Carsten Buch Sivertsen" },
    { member: "Håkon Skånhaug" },
    { member: "Jon Birger Syvertsen" },
    { member: "Torbjørn Sætre" },
    { member: "Martin Thorsen" },
    { member: "Johann Yoon" },
    { member: "Guttorm Aase" },
    { member: "Tone Aass" },
    { activity: "23 Bedriftspresentasjoner" },
    { activity: "Oslotur" },
    { activity: "Roadshow i Oslo" },
    { activity: "Sommerjobber" },
    { activity: "Diplomundersøkelse" },
    { activity: "Trendundersøkelse fra hele Gløshaugen" },
    { activity: "PR-brosjyre" },
    { activity: "UMTS - debatt med Accenture" },
    { activity: "Kortleser" },
    { activity: "Undersøkelsessystem" },
    { activity: "Samarbeidsavtale inngått med Universum" },
  ],

  "2001/2002": [
    { member: "Marte Helene Sølvsberg", role: "Leder" },
    { member: "Caroline Torkildsen", role: "Nestleder" },
    { member: "Barbara K. Andersen" },
    { member: "Kristian Kragerøe Andresen" },
    { member: "Espen Berge" },
    { member: "Rune Bruøygard" },
    { member: "Hilde Charlotte Dahl" },
    { member: "Ole Håkon Eek-Nielsen" },
    { member: "Jon Fløgstad" },
    { member: "Jørgen Færevåg" },
    { member: "Knut-Yngve Heian" },
    { member: "Nina Holck-Steen" },
    { member: "Carl Erik Høy-Petersen" },
    { member: "Merete Ihler" },
    { member: "Elin Irgens" },
    { member: "Anders Johansen" },
    { member: "Andreas Jordell" },
    { member: "David Magnus Nome" },
    { member: "Petter Nygaard" },
    { member: "Erlend Nævdal" },
    { member: "Carsten Buch Sivertsen" },
    { member: "Ida Marie Stolpe Sivertsen" },
    { member: "Lene Skjervheim" },
    { member: "Jon Birger Syvertsen" },
    { member: "Martin Thorsen" },
    { member: "Arne Johan Valen-Sendstad" },
    { member: "Ingrid Ørbeck Vallevik" },
    { member: "Johann Yoon" },
    { member: "Sandra Marie Øyan" },
    { member: "Guttorm Aase" },
    { activity: "37 Bedriftspresentasjoner" },
    { activity: "Nytt design, websider og brosjyrer" },
    { activity: "Oslotur" },
    { activity: "Roadshow i Oslo (promotering av indøk)" },
    { activity: "Stand på Kompetanseforum 2002" },
    { activity: "Sommerjobber" },
    { activity: "Diplomundersøkelse" },
    { activity: "Arbeidssituasjonsundersøkelse (alumni)" },
    { activity: "Ny organisasjonsstruktur" },
  ],
  "2000/2001": [
    { member: "Jan-Børre Vik", role: "Leder" },
    { member: "Asgeir Brenne", role: "Nestleder" },
    { member: "Christian Norman Aass" },
    { member: "Barbara K. Andersen" },
    { member: "Kristian Kragerøe Andresen" },
    { member: "Ole Håkon Eek-Nielsen" },
    { member: "Jon Fanebust" },
    { member: "Lars-Harald Green" },
    { member: "Merete Ihler" },
    { member: "Carl Erik Høy-Petersen" },
    { member: "Knut-Yngve Heian" },
    { member: "Kristian Sten Iversen" },
    { member: "Marianne Storhaug Jensen" },
    { member: "Anders Johansen" },
    { member: "Harald Johnsen" },
    { member: "Andreas Jordell" },
    { member: "Erlend Nævdal" },
    { member: "Lene Sandvoll" },
    { member: "Carsten Buch Sivertsen" },
    { member: "Ida Marie Stolpe Sivertsen" },
    { member: "Helga Stenseth" },
    { member: "Marte Helene Sølvsberg" },
    { member: "Simen Teigre" },
    { member: "Martin Thorsen" },
    { member: "Caroline Torkildsen" },
    { member: "Janne Elisabeth Tranby" },
    { member: "Ingrid Ørbeck Vallevik" },
    { member: "Odd Sverre Østlie" },
    { member: "Sandra Marie Øyan" },
    { activity: "42 Bedriftspresentasjoner" },
    { activity: "Londontur" },
    { activity: "Hydrodag" },
    { activity: "Oslotur" },
    { activity: "Sommerjobber" },
    { activity: "Arbeidssituasjonsundersøkelser" },
    { activity: "Samarbeidsavtaler inngått med Hydro og Dossier" },
    { activity: "Intensjonsavtale inngått med News" },
  ],
  "1999/2000": [
    { member: "Ole Martin Grimsrud", role: "Leder" },
    { member: "Ina Cathrine Myhre", role: "Nestleder" },
    { member: "Tor Erik Aag" },
    { member: "Christian Norman Aass" },
    { member: "Barbara K. Andersen" },
    { member: "Guttorm Andresen" },
    { member: "Asgeir Brenne" },
    { member: "Dag Meidell Dybdahl" },
    { member: "Ole Håkon Eek-Nielsen" },
    { member: "Jon Fanebust" },
    { member: "Lars-Harald Green" },
    { member: "Carl Erik Høy-Petersen" },
    { member: "Kristian Sten Iversen" },
    { member: "Marianne Storhaug Jensen" },
    { member: "Anders Johansen" },
    { member: "Morten Eugene Kamphaug" },
    { member: "Erlend Nævdal" },
    { member: "Ståle Njå" },
    { member: "Inge Norstad" },
    { member: "Christopher Rolsdorph" },
    { member: "Lene Sandvoll" },
    { member: "Erwin Meissner Schau" },
    { member: "Marte Helene Sølvsberg" },
    { member: "Atgeir Takle" },
    { member: "Simen Teigre" },
    { member: "Caroline Torkildsen" },
    { member: "Ingrid Ørbeck Vallevik" },
    { member: "Jan-Børre Vik" },
    { member: "Odd Sverre Østlie" },
    { member: "Sandra Marie Øyan" },
    { activity: "42 Bedriftspresentasjoner" },
    { activity: "Oslotur" },
    { activity: "Foredrag med bl.a. Diderik Schnitler" },
    { activity: "Ekskursjoner til Adresseavisen og Siemens" },
    { activity: "Sommerjobber" },
    { activity: "To arbeidssituasjonsundersøkelser" },
    { activity: "Markedsføring med bl.a. oppslag i TV2" },
    { activity: "Fagkvelder for Alumniforeningen" },
    { activity: "Opprettelse av Samarbeidsutvalget ved ind.øk" },
    { activity: "Samarbeidsavtale med Dolly Dimple`s" },
  ],
  "1998/1999": [
    { member: "Asle Svanøe", role: "Leder" },
    { member: "Guri Lande" },
    { member: "Narve Bjørdal" },
    { member: "Kjetil Ness" },
    { member: "Ståle Njå" },
    { member: "Asgeir Brenne" },
    { member: "Guttorm Andresen" },
    { member: "Knut Olav Rød" },
    { member: "Ole Martin Grimsrud" },
    { member: "Dag Meidell Dybdahl" },
    { member: "Torbjørn Hveding" },
    { member: "Jon Fanebust" },
    { member: "Morten E. Kamphaug" },
    { member: "Odd Sverre Østlie" },
    { member: "Inge Norstad" },
    { member: "Geir Espeskog" },
    { member: "Caroline Østby" },
    { member: "Ina Cathrine Myhre" },
    { member: "Simen Teigre" },
    { member: "Erwin A. M. Schau" },
    { member: "Marianne Storhaug Jensen" },
    { member: "Christopher Rolsdorph" },
    { member: "Gro Stake" },
    { member: "Erlend Nævdal" },
    { member: "Lars-Harald Green" },
    { activity: "Bedriftspresentasjoner" },
    { activity: "Sommerjobber" },
    { activity: "Oslo - og Stavangertur" },
    { activity: "Foredrag med Tom Ruud" },
    { activity: "Etablering Start-NTNU" },
    { activity: "Etablering StudConsult Trondheim" },
  ],
  "1997/1998": [
    { member: "Mats Gottschalk", role: "Leder" },
    { member: "Jørgen Svare (-)" },
    { member: "Gaute Marius Langeland (-)" },
    { member: "Guri Lande" },
    { member: "Guttorm Andresen" },
    { member: "Ståle Njå" },
    { member: "Knut Olav Rød" },
    { member: "Asle Svanøe" },
    { member: "Tore Jacobsen (-)" },
    { activity: "Oslotur" },
    { activity: "Skaffe sommerjobber" },
    { activity: "Bedriftsbesøk hos Nidar og E.C.Dahls" },
    { activity: "Bedriftspresentasjoner" },
  ],
  "1996/1997": [
    { member: "Rune Holmøy", role: "Leder (98)" },
    { member: "Hege Tinnen (-)" },
    { member: "Mikkel Tørud (-)" },
    { member: "Are Stenberg (-)" },
    { member: "Jørgen Svare (-)" },
    { member: "Gaute Marius Langeland (-)" },
    { member: "Anne-Lise Kvaase (-)" },
    { member: "Tore Jacobsen (-)" },
    { member: "Lillian Waagø (98)" },
    { member: "Christine Warloe (98)" },
    { member: "Mats Gottschalk" },
    { member: "Asle Svanøe" },
    { member: "Terje Erikstad (98)" },
    { member: "Ragnar Eggen" },
    { activity: "Oslotur" },
    { activity: "Skaffe sommerjobber" },
    { activity: "Bedriftsbesøk hos Nidar og E.C.Dahls" },
    { activity: "Bedriftspresentasjoner" },
  ],
  "1995/1996": [
    { member: "Halvor Hoddevik (-)", role: "Leder" },
    { member: "Kjetil Jørgensen Dahl (96)" },
    { member: "Hege Tinnen (-)" },
    { member: "Mikkel Tørud (-)" },
    { member: "Are Stenberg (-)" },
    { member: "Jørgen Svare (-)" },
    { member: "Gaute Marius Langeland (-)" },
    { member: "Rune Holmøy (-)" },
    { member: "Anne-Lise Kvaase (-)" },
    { member: "Tore Jacobsen (-)" },
    { member: "Lillian Waagø (-)" },
    { member: "Jørn-Olav Myhre(-)" },
    { member: "Christine Warloe (-)" },
    { member: "Eystein M. Haugaard (97)" },
    { member: "Brynhild Bjørke (-)" },
    { activity: "Oslotur (med besøk hos Andersen Consulting, Saga, ....)" },
    { activity: "Støttekampanje mot nedleggelse av Fakultet for Økonomi og arbeidslivsvitenskap" },
    { activity: "Arbeidssituasjons-undersøkelse 96" },
    { activity: "Bergenstur til NHH-dagene («Uken 96)" },
    { activity: "Skaffe sommerjobber" },
    { activity: "Bedriftsbesøk hos Nidar og E.C.Dahls" },
    { activity: "Bedriftspresentasjoner med P.A.Consulting, CTP, BCG, Telenor, McKinsey" },
  ],
  "1994/1995": [
    { member: "Tor Vegard Vale (96)", role: "Leder" },
    { member: "Klaus A. Hansen (96)" },
    { member: "Lars Wendt (94)" },
    { member: "Johannes T. Aasen (96)" },
    { member: "Kjetil Haugland (95)" },
    { member: "Jacob Børs Lind (95)" },
    { member: "Kari Håvåg (95)" },
    { member: "Monica Martinsen Færøy (95)" },
    { member: "Jan-Helge Kvilstad ()" },
    { member: "Halvor Hoddevik (-)" },
    { member: "Rune Holmøy (-)" },
    { activity: "Workshop om «Etikk i næringslivet»" },
    { activity: "Bedriftsbesøk til Nidar, EC.Dahls og Siemens" },
    { activity: "Laget info-brosjyre om ind.øk-studiet" },
    { activity: "Oslotur" },
    { activity: "Foredrag om økonomisk kriminalitet" },
    { activity: "Arbeidssituasjons-undersøkelse 95" },
  ],
  "1993/1994": [
    { member: "Jan-Olav Arnegård (95)", role: "Leder" },
    { member: "Jacob Børs Lind (95)" },
    { member: "Tor Vegard Vale (96)" },
    { member: "Lars Wendt (94)" },
    { member: "Monica Martinsen Færøy (95)" },
    { member: "Thomas Thorsrud (94)" },
    { member: "Kjetil Are Haugland (95)" },
    { member: "Kari Håvåg (95)" },
    { member: "Johannes T. Aasen (95)" },
    { activity: "Debatt om «Kvinner i norsk næringsliv» (med bl.a. Inger Prebensen(Postbanken))" },
    { activity: "Bedriftsbesøk til Andersen Consulting (med foredrag og workshop)" },
    { activity: "Gjesteforelesning med Terje Mikalsen (tema: «Lederskap i møte med stadige omstillinger»)" },
    {
      activity:
        "Seminar om «Norge uten oljen»(med gjesteforelesninger av Hermod Skånland og Helge Kvammen, påfølgende debatt om dette temaet)",
    },
    { activity: "Undersøkelse av «Nytteverdien av ind-økère» (sendt til arbeidsgivere og bedrifter)" },
  ],
  "1992/1993": [
    { member: "Johannes T. Aasen (95)", role: "Leder" },
    { member: "Kjetil Are Haugland (95)" },
    { member: "Jan-Olav Arnegård (95)" },
    { member: "Lars Wendt (94)" },
    { member: "Frode Lukassen (94)" },
    { member: "Kurt Oddvar Austrått (92)" },
    { member: "Jacob Børs Lind (95)" },
    { member: "Tor Vegard Vale (96)" },
    { member: "Rolf Atle Færden (96)" },
    { activity: "Arrangerte Oslotur" },
    { activity: 'Paneldebatt: "Trondheim-en industriell ørken?"' },
    { activity: "Samarbeidsavtale inngått med Andersen Consulting, nå Accenture" },
  ],
  "1991/1992": [
    { member: "Håkon Ø. Vad (94)", role: "Leder" },
    { member: "Lars Wendt (94)" },
    { member: "Thor Gunnar Olsen (94)" },
    { member: "Kurt Oddvar Austrått (92)" },
    { member: "Hilde Nordpoll (95)" },
    { member: "Kjetil Are Haugland (95)" },
    { member: "Gunvor Bay (95)" },
    { member: "Lars Tarjei Farner (95)" },
    { member: "Ingeborg Flønes (92)" },
    { member: "Marius Kjeldahl (94)" },
    { member: "Frode Lukassen (94)" },
    { member: "Johannes T. Aasen (95)" },
    {
      activity:
        "Stand på NorTech-messen. Invitasjon til samtlige NTH-studenter ble delt ut. Cubus sponset Bindeleddet med klær",
    },
    { activity: "Stand på Åpen Dag under Uka 91" },
    { activity: "Gjesteforeleser Fred. Olsen" },
    { activity: "Laget første arbeidsmarkedsundersøkelse" },
  ],
  "1990/1991": [
    { member: "Arne Landmark (91)" },
    { member: "Lars Wendt (94)" },
    { member: "Marius Kjeldahl (94)" },
    { member: "Kurt Oddvar Austrått (92)" },
    { member: "Kjetil Are Haugland (95)" },
    { member: "Gunvor Bay (95)" },
    { member: "Hilde Nordpoll (95)" },
    { member: "Ingeborg Flønes (92)" },
    { member: "Trond Digranes (93)" },
    { member: "Petter Djupvik (92)" },
    { member: "Lars Klevjer (91)" },
    { member: "Håkon Ø. Vad" },
    { activity: "Nystartet Bindeleddet NTNU på et allmøte etter en periode uten aktivitet" },
    { activity: "Bedriftsbesøk hos Nidar Bergene" },
    { activity: "Hvor kjent er ind.øk? Undersøkelse" },
    { activity: "Gjesteforelesning med Eckbo" },
    { activity: "Stand under åpen dag på NTH" },
    { activity: "Oversetting av faglig interessante artikler" },
  ],
  "1989/1990": [
    { member: "Tom Engevold (90)", role: "Leder" },
    { member: "Nora Skauen (93)" },
    { member: "Arne Landmark (91)" },
    { member: "Kjetil Gaarde (91)" },
    { member: "Trond Digranes (93)" },
  ],
  "1988/1989": [
    { member: "Tom Engevold (90)" },
    { member: "Harald Ø. Wang (90)" },
    { activity: "Bedriftspresentasjoner med McKinsey, Andersen Consulting og Kværner(i samarbeid med maskin)" },
    { activity: "Oppdaterte bedrifts-databasene" },
    { activity: "Skaffet sommerjobber" },
  ],
  "1987/1988": [
    { member: "Jone Stangeland (88)" },
    { member: "Håvard Espedal (89)" },
    { member: "Eigil Stray Spetalen (89)" },
    { member: "Henrik Finsrud (88)" },
    { activity: "Bedriftspresentasjon med Andersen Consulting" },
    { activity: "Sommerjobber (kontakt med professorer)" },
  ],
  "1986/1987": [
    { member: "Bård Benum (87)" },
    { member: "Jon Arne Finnes (87)" },
    { member: "Tom Børre Lindholm (87)" },
    { member: "Jens-Erik Øvreeide (87)" },
    { member: "Tov Sylfest Myklatun (87)" },
    { activity: "Laget og utformet den første brosjyren for ind.øk i 1986" },
    { activity: 'Stand ved jobbmesse i "Royale Electric Garden" (høsten 86)' },
    { activity: "Arrangerte konferanse i Oslo (på Ingeniørenes Hus) med bedriftspresantasjoner og foredrag" },
    { activity: "Bedriftspresentasjoner med Andersen Consulting og Aker Stord (våren 87)" },
    { activity: "Foredrag med student ved INSEAD" },
  ],
};
